export const CONTACT_EMAIL = 'contact@millenniumrealtysf.com'

const fieldLabels = {
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email',
  phone: 'Phone',
  service: 'Service needed',
  message: 'Message',
}

export const submitContactEmail = (event, subject = 'Website inquiry') => {
  event.preventDefault()
  const data = new FormData(event.currentTarget)
  const body = Array.from(data.entries())
    .filter(([, value]) => String(value).trim())
    .map(([key, value]) => `${fieldLabels[key] || key}: ${String(value).trim()}`)
    .join('\n')

  window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}
